import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import './pdf-preview.scss';

export const PdfPreviewScreenContent: React.FC<{
  pdfUrl: string;
}> = ({ pdfUrl }) => {
  const getPdfUrlWithParams = (url: string) => {
    if (url.startsWith('blob:')) {
      return `${url}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`;
    }
    const separator = url.includes('?') ? '&' : '#';
    return `${url}${separator}toolbar=0&navpanes=0&scrollbar=0&view=FitH`;
  };
  return (
    <div className="pdf-preview-container">
      {pdfUrl ? (
        <div className="pdf-viewer-wrapper">
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <Viewer
              fileUrl={pdfUrl}
              defaultScale={SpecialZoomLevel.PageWidth}
            />
          </Worker>
        </div>
      ) : (
        <div className="pdf-preview-error">
          <span className="font-semibold">Something went wrong!</span>
        </div>
      )}
    </div>
  );
};
